// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"218":"4107f408","451":"c5b3c695","561":"4c9b29c1","936":"3cc9bc0d","945":"4c6dfd6a"}[chunkId] + ".css";
};